import React, {Fragment} from 'react';

import {Filter} from 'presentation/components/Filter';
import {useOdontoSearchBar} from './hooks/useOdontoSearchBar';
import {OdontoSearchBarProps} from './types';
import {Stack} from '@mui/material';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {UnitsFilterDrawer} from 'presentation/modules/booking/shared/ui/components/UnitsFilterDrawer';
import {OdontoFilterByLetter} from './components/OdontoFilterByLetter';
import {CurrentLocation} from 'presentation/modules/booking/shared/ui/components/CurrentLocation';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new';

const {apply, nearestDates, filter} = translations['pt-br'].commons;

export function OdontoSearchBar({
	placeholder,
	readOnly,
	activeStep,
	searchDataTagId,
}: OdontoSearchBarProps) {
	const {
		showFilter,
		handleOpenDrawer,
		filterIsActive,
		drawerButtonTagId,
		openDrawerState,
		showGeolocationFilterDrawer,
		handleCloseDrawer,
		distanceFilterAtMaxDistance,
		handleConfirmDistance,
		handleClearDistance,
		districtGeolocationState,
		setDistrictGeolocationState,
		selectedFilterGeolocationState,
		setSelectedFilterGeolocationState,
		showFilterByLetter,
		showCurrentLocation,
		showProfessionalFilters,
		shift,
		PERIODS,
		handleClearShift,
		handleConfirmShift,
		setExternalOpenDateModal,
		externalOpenDateModal,
		availableDates,
		currentSelectedDate,
		handleChangeDate,
		disabledSelectionDate,
		SERVING_PEOPLE_WITH_DISABILITIES,
		showOdontoUnitsDrawer,
		handleClearDisability,
		handleConfirmDisability,
	} = useOdontoSearchBar({activeStep});

	return (
		<Filter.Root>
			<Stack direction={'row'} gap={1}>
				<Filter.Search
					dataTagId={searchDataTagId}
					placeholder={placeholder}
					readOnly={readOnly}
				/>

				{showFilter ? (
					<Fragment>
						<Filter.Button
							onClick={handleOpenDrawer}
							count={filterIsActive ? 1 : undefined}
							data-tag-id={drawerButtonTagId}
						/>

						<UnitsFilterDrawer
							flowType={FlowEnum.ODONTO}
							openDrawerState={openDrawerState}
							handleOpenDrawer={handleOpenDrawer}
							handleCloseDrawer={handleCloseDrawer}
							showDistanceDrawer={false}
							showOdontoDrawer={showOdontoUnitsDrawer}
							showGeolocationFilterDrawer={showGeolocationFilterDrawer}
							servingPeopleWithDisabilities={SERVING_PEOPLE_WITH_DISABILITIES}
							handleClearDisability={handleClearDisability}
							handleConfirmDisability={handleConfirmDisability}
							distanceFilterAtMaxDistance={distanceFilterAtMaxDistance}
							handleConfirmDistance={handleConfirmDistance}
							handleClearDistance={handleClearDistance}
							districtGeolocationState={districtGeolocationState}
							setDistrictGeolocationState={setDistrictGeolocationState}
							selectedFilterGeolocationState={selectedFilterGeolocationState}
							setSelectedFilterGeolocationState={setSelectedFilterGeolocationState}
						/>
					</Fragment>
				) : null}
			</Stack>

			{showFilterByLetter ? <OdontoFilterByLetter /> : null}

			{showProfessionalFilters ? (
				<Stack flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
					<Filter.Date
						dataTagId={{
							openButton: AppointmentBookingEnum.CLICK_DATAS_MAIS_PROXIMAS,
						}}
						currentFirstDate={currentSelectedDate}
						selectFirstDate={handleChangeDate}
						customOpenModalButton={nearestDates}
						customLabelConfirmButton={apply}
						availableDates={availableDates}
						disableConfirmButton={disabledSelectionDate}
						externalOpen={externalOpenDateModal}
						onAbandonModal={() => setExternalOpenDateModal(false)}
					/>
					<Filter.Button onClick={handleOpenDrawer} count={shift ? 1 : undefined} />
					<Drawer.Root
						open={openDrawerState}
						onOpen={handleOpenDrawer}
						onClose={() => handleCloseDrawer(true)}
						width={'420px'}
						sx={{zIndex: 9000}}>
						<Drawer.Header title={filter} onClose={() => handleCloseDrawer(true)} />
						<Drawer.ContentListByCategory categoryList={[PERIODS]} />
						<Drawer.Footer
							firstButtonOnClick={handleClearShift}
							secondButtonOnClick={handleConfirmShift}
						/>
					</Drawer.Root>
				</Stack>
			) : null}

			{showCurrentLocation ? (
				<CurrentLocation
					dataTagId={AppointmentBookingEnum.CLICK_ALTERAR_LOCALIZACAO}
					flowType={FlowEnum.ODONTO}
				/>
			) : null}
		</Filter.Root>
	);
}
